import Alert from '@/components/dialogs/alert'
import {create} from 'vue-modal-dialogs'

export default create(Alert, 'content')
